import React, { useCallback, useState } from 'react'
import { ErrorStyles, FabButtonStyles, TeacherIdleStyles } from '../Style'
import { Button } from 'components/Form'
import { AnimatePresence } from "motion/react"
import { IconButton, SvgIcon } from '@mui/material'
import { ReactComponent as RefreshPermissionIcon } from 'assets/icons/RefreshPermission.svg';
import { Img } from 'styles/GlobalStyle'
import { ErrorMic_Go } from 'assets'
import { ReactComponent as MicButton } from 'assets/icons/MicButton.svg'
import * as motion from "motion/react-client"
import MicErrorsAlert from './MicErrorsAlert'

const Error = (props) => {
    const { checkAgain, error, isTeacherCheck, start } = props

    const [openMicErrorsAlert, setOpenMicErrorsAlert] = useState(false)

    const openErrorListAlert = useCallback(() => {
        setOpenMicErrorsAlert(true)
    }, [])

    if (isTeacherCheck) {
        return (
            <AnimatePresence>
                <motion.div
                    exit={{ opacity: 0 }}
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ duration: 0.7 }}
                    key="error-mic-teacher"
                >
                    <TeacherIdleStyles>
                        <div className='instructions'>{error}</div>
                        <div className='check-mic-teacher clickable' onClick={start}>
                            <MicButton />
                        </div>
                        <Img className="cartoon-corner" style={{ height: 216 }} src={ErrorMic_Go} />
                    </TeacherIdleStyles>
                </motion.div>
            </AnimatePresence>
        )
    }

    return (
        <>
            <motion.div
                exit={{ opacity: 0 }}
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.7 }}
                key="error-mic"
            >
                <ErrorStyles>
                    <div className='title'>{"יש בעייה במיקרופון"}</div>
                    <Button
                        className="solid-round"
                        color="primary500"
                        label="מה זה יכול להיות?"
                        action={openErrorListAlert}
                    />
                    <div className='text bold'>{error}</div>
                    <div className='text'>
                        <div>{"אחרי שסדרתם"}</div>
                        <div>{"לחצו על כפתור בדיקה חוזרת"}</div>
                    </div>
                    <div className='refresh-check-permissions-img'>

                        <div className='wrap-fab-button'>
                            <FabButtonStyles onClick={checkAgain}>
                                <IconButton onClick={() => { }}>
                                    <SvgIcon fontSize='small' component={RefreshPermissionIcon} inheritViewBox />
                                </IconButton>
                            </FabButtonStyles>
                        </div>

                        <div className='side-cartoon'>
                            <Img src={ErrorMic_Go} />
                        </div>
                    </div>
                </ErrorStyles >
            </motion.div>
            {openMicErrorsAlert && <MicErrorsAlert handleAlert={setOpenMicErrorsAlert} />}
        </>
    )
}

export default Error